import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import NotFound from 'pages/404'
import useQueryString from '@cannect/hooks/useQueryString'
import { useRecurrencyAccess } from '@cannect/services/resources/recurrency/hooks'
import { SUBSCRIPTIONS_PAGE_PATH } from '@cannect/services/resources/recurrency/constants'
import { SubscriptionList } from './List/SubscriptionList'
import { SubscriptionListSkeleton } from './List/SubscriptionListSkeleton'
import { SubscriptionDetail } from './Detail/SubscriptionDetail'

// `assinaturas-<id>` → id inteiro positivo; qualquer outra coisa é inválida.
export const parseSubscriptionId = (page?: string | null) => {
  const raw = (page || '').replace(/^assinaturas-/, '')
  return /^\d+$/.test(raw) && Number(raw) > 0 ? Number(raw) : null
}

const RedirectToList = () => {
  const history = useHistory()
  useEffect(() => {
    history.replace(SUBSCRIPTIONS_PAGE_PATH)
  }, [history])
  return null
}

// "Minhas assinaturas" (008). Só paciente com Compra Recorrente ligada; o
// resto vê o NotFound, sem nenhuma chamada a /my-account/recurrency.
const Subscriptions = () => {
  const { filters } = useQueryString()
  const { enabled, isLoading } = useRecurrencyAccess()
  const page = String(filters.pagina || '')

  if (!enabled) return <NotFound />
  if (isLoading) return <SubscriptionListSkeleton />

  if (page === 'assinaturas') return <SubscriptionList />

  const id = parseSubscriptionId(page)
  if (!id) return <RedirectToList />

  return <SubscriptionDetail key={id} id={id} />
}

// `perfil-receitas` (link dos e-mails antigos) → envio de receita da assinatura.
export const RecipesAlias = () => {
  const history = useHistory()
  const { enabled, isLoading } = useRecurrencyAccess()

  useEffect(() => {
    if (enabled) history.replace(`${SUBSCRIPTIONS_PAGE_PATH}&documento=receita`)
  }, [enabled, history])

  if (!enabled && !isLoading) return <NotFound />
  return null
}

export default Subscriptions
